import script from "./MenuSlot.vue?vue&type=script&lang=js"
export * from "./MenuSlot.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__